import React from "react";
import { Page } from "./style.js";
import clsx from "clsx";

function Printable(props) {
  const { landscape, page, children, pageNumberClass } = props;
  return (
    <Page className={clsx({ landscape })}>
      <p className={`page-number ${pageNumberClass ? pageNumberClass : ""}`}>{page}</p>
      {children}
    </Page>
  );
}

export default Printable;



// WEBPACK FOOTER //
// ./src/components/Printable/index.jsx